var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tls-application-center-home" },
    [
      _c("div", { staticClass: "tls-button-banner" }, [
        _c(
          "div",
          {
            staticClass: "tls-button-banner--img",
            style: {
              backgroundImage:
                "url(" +
                _vm._.get(
                  _vm.residenceCountryCMSData,
                  "countryImage.data.full_url"
                ) +
                ")"
            }
          },
          [
            _c("div", { staticClass: "tls-button-banner--content" }, [
              _c("div", { staticClass: "tls-home-text-group" }, [
                _c("div", { staticClass: "tls-home-title-flex" }, [
                  _c("div", {
                    directives: [
                      {
                        name: "dompurify-html",
                        rawName: "v-dompurify-html",
                        value: _vm._.get(
                          _vm.applicationCenterHomeCmsData,
                          "title"
                        ),
                        expression:
                          "_.get(applicationCenterHomeCmsData, 'title')"
                      }
                    ],
                    staticClass: "tls-simple-text -color-white -size-18"
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "tls-image",
                    attrs: {
                      src: _vm._.get(
                        _vm.residenceCountryCMSData,
                        "countryFlag.data.full_url"
                      ),
                      alt: "Country flag"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("h1", {
                  directives: [
                    {
                      name: "dompurify-html",
                      rawName: "v-dompurify-html",
                      value: _vm._.get(
                        _vm.applicationCenterHomeCmsData,
                        "subtitle"
                      ),
                      expression:
                        "_.get(applicationCenterHomeCmsData, 'subtitle')"
                    }
                  ],
                  staticClass: "tls-heading-1"
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tls-button-banner--action" }, [
                _c(
                  "button",
                  {
                    staticClass: "button-neo-outer -primary",
                    on: { click: _vm.redirectToOpeningHours }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm._.get(
                            _vm.applicationCenterHomeCmsData,
                            "opening_hours"
                          )
                        ) +
                        "\n                    "
                    )
                  ]
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tls-application-center-home--card-info" }, [
        _c("div", { staticClass: "tls-large-card-info" }, [
          _c("div", { staticClass: "tls-card-lg" }, [
            _c("h2", { staticClass: "tls-heading-2" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm._.get(_vm.applicationCenterHomeCmsData, "card_title")
                  ) +
                  "\n                "
              )
            ]),
            _vm._v(" "),
            _c("div", {
              directives: [
                {
                  name: "dompurify-html",
                  rawName: "v-dompurify-html",
                  value: _vm._.get(
                    _vm.applicationCenterHomeCmsData,
                    "card_body"
                  ),
                  expression: "_.get(applicationCenterHomeCmsData, 'card_body')"
                }
              ],
              staticClass: "tls-simple-text -size-16"
            })
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tls-application-center-home--content" },
        [
          _c("div", { staticClass: "tls-application-center-home--flow" }, [
            _vm.servicesCmsData.length > 0
              ? _c(
                  "div",
                  { staticClass: "tls-flow-card" },
                  _vm._l(_vm.servicesCmsData, function(service) {
                    return _c("div", { staticClass: "tls-flow-card--item" }, [
                      _c(
                        "div",
                        {
                          staticClass: "tls-flow-item tls-flow-service-item",
                          on: {
                            click: function($event) {
                              return _vm.goToServiceProcessPage(service)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "tls-flow-service-items" }, [
                            _c("img", {
                              staticClass: "tls-flow-item--icon",
                              attrs: {
                                src: _vm._.get(service, "icon.data.url")
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tls-flow-item--content" }, [
                            _c("div", {
                              directives: [
                                {
                                  name: "dompurify-html",
                                  rawName: "v-dompurify-html",
                                  value: _vm._.get(service, "title"),
                                  expression: "_.get(service, 'title')"
                                }
                              ],
                              staticClass:
                                "tls-simple-text -weight-bold -color-black"
                            }),
                            _vm._v(" "),
                            _c("div", {
                              directives: [
                                {
                                  name: "dompurify-html",
                                  rawName: "v-dompurify-html",
                                  value: _vm._.get(
                                    service,
                                    "short_description"
                                  ),
                                  expression:
                                    "_.get(service, 'short_description')"
                                }
                              ],
                              staticClass: "tls-simple-text -color-black"
                            })
                          ])
                        ]
                      )
                    ])
                  }),
                  0
                )
              : _c("div", { staticClass: "tls-flow-card" }, [
                  _c("div", { staticClass: "tls-flow-card--item" }, [
                    _c("div", { staticClass: "tls-flow-item" }, [
                      _c("div", { staticClass: "tls-flow-service-items" }, [
                        _c("img", {
                          staticClass: "tls-flow-item--icon",
                          attrs: {
                            src: _vm._.get(
                              _vm.applicationCenterHomeCmsData,
                              "visa_flow_first_step_img.data.url"
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tls-flow-item--content" }, [
                        _c("div", {
                          directives: [
                            {
                              name: "dompurify-html",
                              rawName: "v-dompurify-html",
                              value: _vm._.get(
                                _vm.applicationCenterHomeCmsData,
                                "visa_flow_first_step"
                              ),
                              expression:
                                "_.get(applicationCenterHomeCmsData, 'visa_flow_first_step')"
                            }
                          ],
                          staticClass: "tls-simple-text -color-black"
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tls-flow-card--item" }, [
                    _c("div", { staticClass: "tls-flow-item" }, [
                      _c("div", { staticClass: "tls-flow-service-items" }, [
                        _c("img", {
                          staticClass: "tls-flow-item--icon",
                          attrs: {
                            src: _vm._.get(
                              _vm.applicationCenterHomeCmsData,
                              "visa_flow_second_step_img.data.url"
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tls-flow-item--content" }, [
                        _c("div", {
                          directives: [
                            {
                              name: "dompurify-html",
                              rawName: "v-dompurify-html",
                              value: _vm._.get(
                                _vm.applicationCenterHomeCmsData,
                                "visa_flow_second_step"
                              ),
                              expression:
                                "_.get(applicationCenterHomeCmsData, 'visa_flow_second_step')"
                            }
                          ],
                          staticClass: "tls-simple-text -color-black"
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "tls-flow-card--item" }, [
                    _c("div", { staticClass: "tls-flow-item" }, [
                      _c("div", { staticClass: "tls-flow-service-items" }, [
                        _c("img", {
                          staticClass: "tls-flow-item--icon",
                          attrs: {
                            src: _vm._.get(
                              _vm.applicationCenterHomeCmsData,
                              "visa_flow_third_step_img.data.url"
                            )
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tls-flow-item--content" }, [
                        _c("div", {
                          directives: [
                            {
                              name: "dompurify-html",
                              rawName: "v-dompurify-html",
                              value: _vm._.get(
                                _vm.applicationCenterHomeCmsData,
                                "visa_flow_third_step"
                              ),
                              expression:
                                "_.get(applicationCenterHomeCmsData, 'visa_flow_third_step')"
                            }
                          ],
                          staticClass: "tls-simple-text -color-black"
                        })
                      ])
                    ])
                  ])
                ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tls-application-center-home--avs" }, [
            _c(
              "div",
              { staticClass: "tls-application-center-home-avs--heading" },
              [
                _c("h2", { staticClass: "tls-heading-2" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm._.get(_vm.applicationCenterHomeCmsData, "avs_title")
                      ) +
                      "\n                "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "tls-application-center-home-avs--content tls-card-list-box"
              },
              [
                _c(
                  "div",
                  { staticClass: "tls-card-info-list" },
                  _vm._l(_vm.avsList, function(avs) {
                    return _c(
                      "div",
                      { staticClass: "tls-card-info-list--item" },
                      [
                        _c("div", { staticClass: "tls-card-info" }, [
                          _c("div", { staticClass: "tls-card-info--img" }, [
                            _c("img", {
                              staticClass: "tls-card-info--icon",
                              attrs: {
                                src: _vm._.get(avs, "avs.image_url")
                                  ? _vm._.get(avs, "avs.image_url")
                                  : _vm._.get(avs, "avs.image.data.url")
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tls-card-info--content" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "tls-simple-text -color-main -weight-bold -size-16"
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm._.get(avs, "name")
                                        ? _vm._.get(avs, "name")
                                        : _vm._.get(avs, "avs.name")
                                        ? _vm._.get(avs, "avs.name")
                                        : _vm._.get(avs, "avs.sku")
                                    ) +
                                    "\n                                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._.get(avs, "avs_notice") &&
                            _vm._.get(avs, "avs_notice") !== _vm.emptyNotice
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "tls-simple-text -color-primetime -m-tb-4 -weight-bold -size-14"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.$t(_vm._.get(avs, "avs_notice"))
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._.get(avs, "price") > 0 &&
                            _vm._.get(avs, "currency.code") !== _vm.onDemand
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "tls-simple-text -weight-bold -size-16"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm._.get(avs, "price")) +
                                        " " +
                                        _vm._s(
                                          _vm._.get(avs, "currency.name") ||
                                            _vm._.get(avs, "currency.code")
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "tls-simple-text -weight-bold -size-16"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm._.get(
                                            _vm.onDemandCurrency,
                                            "name"
                                          )
                                            ? _vm._.get(
                                                _vm.onDemandCurrency,
                                                "name"
                                              )
                                            : _vm.onDemand
                                        ) +
                                        "\n                                "
                                    )
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "tls-card-info--content-paragraph"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "tls-simple-text -size-16" },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm._.get(avs, "shortDescription")
                                            ? _vm._.get(avs, "shortDescription")
                                            : _vm._.get(
                                                avs,
                                                "avs.short_description"
                                              )
                                        ) +
                                        "\n                                    "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._.get(avs, "longDescription") !== "" ||
                            _vm._.get(avs, "avs.long_description") !== ""
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "tls-card-info--content-button"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "tls-button-dynamic",
                                        on: {
                                          click: function($event) {
                                            return _vm.onAVSMoreInfoClick(avs)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "tls-button-dynamic--text"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "tls-simple-text -color-primary -size-19"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                " +
                                                    _vm._s(
                                                      _vm._.get(
                                                        _vm.keywords,
                                                        "more_info"
                                                      )
                                                    ) +
                                                    "\n                                            "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._m(1, true)
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm._.get(
            _vm.applicationCenterCMSModel,
            "visa_application_assistance_link"
          ) &&
          _vm._.get(
            _vm.applicationCenterCMSModel,
            "visa_application_assistance_button"
          )
            ? _c(
                "div",
                { staticClass: "tls-application-center-home--visa-start" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "tls-application-center-home-visa-start--heading"
                    },
                    [
                      _c("h2", { staticClass: "tls-heading-2" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm._.get(
                                _vm.applicationCenterCMSModel,
                                "visa_application_assistance_title"
                              )
                            ) +
                            "\n                "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "tls-application-center-home-visa-start--button"
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "tls-button-primary",
                          attrs: {
                            "data-tls-value": "start_application_without_visa"
                          },
                          on: {
                            click: function($event) {
                              _vm.startVisaApplication(
                                _vm._.get(
                                  _vm.applicationCenterCMSModel,
                                  "visa_application_assistance_link"
                                )
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm._.get(
                                  _vm.applicationCenterCMSModel,
                                  "visa_application_assistance_button"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm._.get(_vm.applicationCenterHomeCmsData, "hide_boot_section")
            ? _c(
                "div",
                { staticClass: "tls-application-center-home--visa-start" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "tls-application-center-home-visa-start--heading"
                    },
                    [
                      _c("h2", { staticClass: "tls-heading-2" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm._.get(
                                _vm.applicationCenterHomeCmsData,
                                "start_app_title"
                              )
                            ) +
                            "\n                "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "tls-application-center-home-visa-start--button"
                    },
                    [
                      _vm._.get(
                        _vm.applicationCenterHomeCmsData,
                        "start_app_button_without_visa_link"
                      )
                        ? _c(
                            "button",
                            {
                              staticClass: "tls-button-primary",
                              attrs: {
                                "data-tls-value":
                                  "start_application_without_visa"
                              },
                              on: {
                                click: function($event) {
                                  _vm.startVisaApplication(
                                    _vm._.get(
                                      _vm.applicationCenterHomeCmsData,
                                      "start_app_button_without_visa_link"
                                    )
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._.get(
                                      _vm.applicationCenterHomeCmsData,
                                      "start_app_button_without_visa"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._.get(
                        _vm.applicationCenterHomeCmsData,
                        "start_app_button_link"
                      )
                        ? _c(
                            "button",
                            {
                              staticClass: "tls-button-primary",
                              attrs: { "data-tls-value": "start_application" },
                              on: {
                                click: function($event) {
                                  _vm.startVisaApplication(
                                    _vm._.get(
                                      _vm.applicationCenterHomeCmsData,
                                      "start_app_button_link"
                                    )
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm._.get(
                                      _vm.applicationCenterHomeCmsData,
                                      "start_app_button"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._.get(_vm.applicationCenterCMSModel, "special_news")
            ? _c(
                "div",
                { staticClass: "tls-application-center-home--special-news" },
                [
                  _c("div", { staticClass: "tls-warning-info" }, [
                    _c("div", {
                      directives: [
                        {
                          name: "dompurify-html",
                          rawName: "v-dompurify-html",
                          value: _vm._.get(
                            _vm.applicationCenterCMSModel,
                            "special_news",
                            ""
                          ),
                          expression:
                            "_.get(applicationCenterCMSModel, 'special_news', '')"
                        }
                      ],
                      staticClass: "tls-simple-text -color-main -weight-bold"
                    })
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          Object.keys(_vm.swiperOption).length &&
          _vm._.get(_vm.bannerCarousel, "0.carousel")
            ? _c(
                "swiper",
                {
                  ref: "mySwiper",
                  staticClass: "swiper el-carousel -pc",
                  attrs: { options: _vm.swiperOption }
                },
                _vm._l(_vm._.get(_vm.bannerCarousel, "0.carousel"), function(
                  carousel
                ) {
                  return _c(
                    "swiper-slide",
                    {
                      key: _vm._.get(carousel, "img_link"),
                      staticClass: "swiper-slide"
                    },
                    [
                      _c(
                        "a",
                        { attrs: { href: _vm._.get(carousel, "link") } },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm._.get(carousel, "img_link"),
                              alt: ""
                            }
                          })
                        ]
                      )
                    ]
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          Object.keys(_vm.swiperOption).length &&
          _vm._.get(_vm.bannerCarousel, "0.carousel_mobile")
            ? _c(
                "swiper",
                {
                  ref: "mySwiper",
                  staticClass: "swiper el-carousel-mobile",
                  attrs: { options: _vm.swiperOption }
                },
                _vm._l(
                  _vm._.get(_vm.bannerCarousel, "0.carousel_mobile"),
                  function(carousel) {
                    return _c(
                      "swiper-slide",
                      {
                        key: _vm._.get(carousel, "img_link"),
                        staticClass: "swiper-slide"
                      },
                      [
                        _c(
                          "a",
                          { attrs: { href: _vm._.get(carousel, "link") } },
                          [
                            _c("img", {
                              attrs: {
                                src: _vm._.get(carousel, "img_link"),
                                alt: ""
                              }
                            })
                          ]
                        )
                      ]
                    )
                  }
                ),
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showPopup
        ? _c("popup", {
            attrs: {
              "popup-component-name": "simple-text",
              "popup-title": _vm._.get(_vm.moreAvsInfoData, "name"),
              "popup-data": {
                simpleText: _vm._.get(_vm.moreAvsInfoData, "long_description"),
                videoLink: _vm._.get(_vm.moreAvsInfoData, "video_url")
              },
              hasCancelAction: false,
              hasConfirmAction: false
            },
            on: { "close-action": _vm.closeAvsPopup }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.floatingPromptCMSData.floating_prompt
        ? _c("div", {
            directives: [
              {
                name: "dompurify-html",
                rawName: "v-dompurify-html",
                value: _vm.floatingPromptCMSData.floating_prompt,
                expression: "floatingPromptCMSData.floating_prompt"
              }
            ],
            staticClass: "floating_prompt"
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tls-large-card-info--decoration" }, [
      _c("div", { staticClass: "tls-decoration-vertical-lines -blue" }, [
        _c("div", { staticClass: "tls-line1" }),
        _vm._v(" "),
        _c("div", { staticClass: "tls-line2" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tls-button-dynamic--decoration" }, [
      _c("div", { staticClass: "tls-line1" }),
      _vm._v(" "),
      _c("div", { staticClass: "tls-line2" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }